import { createActions, handleActions } from 'redux-actions';

const actions = createActions({
    SHARED_DATA_FETCHING: () => ({}),
    SHARED_DATA_LOADED: ({
        regions,
        counties,
        boroughs,
        businessEstates,
        propertyInsurances,
        agreementTypes,
        propertyTypes,
        settings,
    }) => ({
        regions,
        counties,
        boroughs,
        businessEstates,
        propertyInsurances,
        agreementTypes,
        propertyTypes,
        settings,
    }),
});

const initialState = {
    error: null,
    fetching: false,
    finishedLoading: false,
    regions: null,
    counties: null,
    boroughs: null,
    businessEstates: null,
    propertyInsurances: null,
    agreementTypes: null,

    // keep certain enums in a central location for consistency
    propertyStatuses: {
        AVAILABLE: 'Available',
        UNDER_OFFER: 'Under Offer',
        HIDE: 'Hide',
        NOW_LET: 'Now Let',
    },

    propertyPromotionTypes: {
        NO_OFFER: 'No offer',
        FIXED_AMOUNT_OFF: 'Fixed amount off rent',
        RENT_FREE_MONTHS_FIRST_YEAR: 'Rent free months – first year only',
        RENT_FREE_MONTHS: 'X rent free months',
        RECENTLY_REDUCED: 'Recently reduced',
        COMING_SOON: 'Coming soon',
    },
};

export default handleActions(
    {
        [actions.sharedDataFetching]: (state, action) =>
            Object.assign({}, initialState, {
                fetching: true,
            }),

        [actions.sharedDataLoaded]: {
            next: (state, action) => {
                const regions = action.payload.regions
                    ? action.payload.regions.reduce((result, region) => {
                          result[region.regionId] = region;
                          return result;
                      }, {})
                    : {};

                const counties = action.payload.counties
                    ? action.payload.counties.reduce((result, county) => {
                          result[county.countyId] = county;
                          return result;
                      }, {})
                    : {};

                const boroughs = action.payload.boroughs
                    ? action.payload.boroughs.reduce((result, borough) => {
                          result[borough.boroughId] = borough;
                          return result;
                      }, {})
                    : {};

                const businessEstates = action.payload.businessEstates
                    ? action.payload.businessEstates.reduce(
                          (result, businessEstate) => {
                              result[
                                  businessEstate.businessEstateId
                              ] = businessEstate;
                              return result;
                          },
                          {}
                      )
                    : {};

                const propertyInsurances = action.payload.propertyInsurances
                    ? action.payload.propertyInsurances.reduce(
                          (result, propertyInsurance) => {
                              result[
                                  propertyInsurance.propertyInsuranceId
                              ] = propertyInsurance;
                              return result;
                          },
                          {}
                      )
                    : {};

                const agreementTypes = action.payload.agreementTypes
                    ? action.payload.agreementTypes.reduce(
                          (result, propertyAgreementType) => {
                              result[
                                  propertyAgreementType.propertyAgreementTypeId
                              ] = propertyAgreementType;
                              return result;
                          },
                          {}
                      )
                    : {};

                const propertyTypes = action.payload.propertyTypes
                    ? action.payload.propertyTypes.reduce(
                          (result, propertyType) => {
                              result[
                                  propertyType.propertyTypeId
                              ] = propertyType;
                              return result;
                          },
                          {}
                      )
                    : {};

                return Object.assign({}, initialState, {
                    boroughs,
                    businessEstates,
                    counties,
                    finishedLoading: true,
                    regions,
                    propertyInsurances,
                    agreementTypes,
                    propertyTypes,
                    settings: action.payload.settings,
                });
            },
            throw: (state, action) => {
                return Object.assign({}, initialState, {
                    error: true,
                    finishedLoading: false,
                });
            },
        },
    },
    initialState
);

export const loadSharedData = () => {
    return (dispatch, getState, api) => {
        dispatch(actions.sharedDataFetching());

        return Promise.all([
            api.get('/properties/regions'),
            api.get('/properties/counties'),
            api.get('/properties/boroughs'),
            api.get('/properties/businessestates'),
            api.get('/properties/propertyinsurances'),
            api.get('/properties/propertyagreementtypes'),
            api.get('/properties/propertytypes'),
            api.get('/settings'),
        ])
            .then(results => {
                const data = {
                    regions: results[0].data,
                    counties: results[1].data,
                    boroughs: results[2].data,
                    businessEstates: results[3].data,
                    propertyInsurances: results[4].data,
                    agreementTypes: results[5].data,
                    propertyTypes: results[6].data,
                    settings: results[7].data,
                };

                dispatch(actions.sharedDataLoaded(data));
            })
            .catch(err => {
                dispatch(actions.sharedDataLoaded(err));
            });
    };
};



// WEBPACK FOOTER //
// ./src/redux/reducers/shared.js